import { Accordion, Checkbox, Drawer, Layout, Text } from '@loadsmart/miranda-react'
import type { MirandaChangeEvent, WCCheckbox } from '@loadsmart/miranda-react'
import { useState } from 'react'

import { TableColumn } from '../../../models/client/reports'

type TableDrawerProps = {
  open: boolean
  handleClose: () => void
  columns: TableColumn[]
  activeColumns: TableColumn[]
  setActiveColumns: (columns: TableColumn[]) => void
}

function ColumnSection({
  columns,
  activeColumns,
  setActiveColumns,
  type,
}: {
  columns: TableColumn[]
  activeColumns: TableColumn[]
  setActiveColumns: (columns: TableColumn[]) => void
  type: string
}) {
  const onColumnCheck = (event: MirandaChangeEvent<WCCheckbox>) => {
    const { id, checked } = event.target
    const column = columns.find((currentColumn) => currentColumn.value === id)

    if (checked) {
      setActiveColumns([...activeColumns, column])
    } else {
      setActiveColumns(activeColumns.filter((activeColumn) => activeColumn.value !== id))
    }
  }

  return (
    <Layout.Stack>
      <Text variant="body-md-bold">{type}</Text>
      <Layout.Stack>
        {columns
          .filter((column) => column.type === type.toLowerCase())
          .map((column) => (
            <Checkbox
              id={column.value}
              name={column.label}
              key={column.value}
              onChange={onColumnCheck}
              checked={activeColumns.some((activeColumn) => activeColumn.value === column.value)}
              disabled={column.value === 'assetType'}
            >
              {column.label}
            </Checkbox>
          ))}
      </Layout.Stack>
    </Layout.Stack>
  )
}

export function TableDrawer({
  open,
  handleClose,
  columns,
  activeColumns,
  setActiveColumns,
}: TableDrawerProps) {
  const [expanded, setExpanded] = useState(true)

  const handleToggle = () => {
    setExpanded(!expanded)
  }

  return (
    <Drawer open={open} onClose={handleClose} size="medium">
      <Drawer.Header>
        <Text variant="heading-md-bold">Table settings</Text>
        <Drawer.Close />
      </Drawer.Header>
      <Drawer.Body>
        <Accordion expanded={expanded} onToggle={handleToggle}>
          <Accordion.Title>Table columns</Accordion.Title>
          <Accordion.Content>
            <Layout.Stack gap="spacing-10">
              <Layout.Grid>
                <ColumnSection
                  columns={columns}
                  activeColumns={activeColumns}
                  setActiveColumns={setActiveColumns}
                  type="General"
                />
                <ColumnSection
                  columns={columns}
                  activeColumns={activeColumns}
                  setActiveColumns={setActiveColumns}
                  type="Load"
                />
              </Layout.Grid>
              <Layout.Grid>
                <ColumnSection
                  columns={columns}
                  activeColumns={activeColumns}
                  setActiveColumns={setActiveColumns}
                  type="Chassis"
                />
                <ColumnSection
                  columns={columns}
                  activeColumns={activeColumns}
                  setActiveColumns={setActiveColumns}
                  type="Tractor"
                />
              </Layout.Grid>
            </Layout.Stack>
          </Accordion.Content>
        </Accordion>
      </Drawer.Body>
    </Drawer>
  )
}
